module.exports = __webpack_public_path__ + "img/about_logo_17.2e2b808f.png";